import { FlexColumn } from "@/components/Flex";
import { spacing } from "@/utils/spacing";

/**
 * A normal flex column with header section on top
 */
const WithPreviewerContentSection = ({
    renderGrid,
    renderHeader,
}: {
    renderGrid: () => React.ReactNode;
    renderHeader: () => React.ReactNode;
}) => (
    <FlexColumn as="section">
        <div style={{ marginBottom: spacing.SM }} data-testid="auto-id-2fefb24e-8c45-44a2-9924-9f3a33b71c70">
            {renderHeader()}
        </div>
        {renderGrid()}
    </FlexColumn>
);

export default WithPreviewerContentSection;
